import config from '@packages/config';

/**
 * Resolve a relative endpoint to an absolute URL.
 *
 * Defaults to staging server (https://{tenantId}.empirie.dev) in development. see `env.local` file.
 *
 * Use MSW if necessary to mock the relevant endpoints, e.g. for Storybook
 */
export const resolveSearchApiEndpoint = (endpoint: string) =>
  `${typeof window !== 'undefined' ? '' : process.env.SEARCH_SERVER_HOST}${endpoint}`;
export const resolveApiEndpoint = (endpoint: string) =>
  `${typeof window !== 'undefined' ? '' : process.env.SERVER_HOST}${endpoint}`;

export const API_URL = resolveSearchApiEndpoint(config.apiEndpoints.search);
export const SEARCH_FILTER_URL = resolveSearchApiEndpoint(config.apiEndpoints.searchFilter);
export const SEARCH_PRODUCT_URL = resolveSearchApiEndpoint(config.apiEndpoints.searchProduct);
export const SEARCH_SEO_API_URL = resolveApiEndpoint(config.apiEndpoints.searchSeo);
